<template>
  <div class="buttons-outer">
    <div class="button-outer button-cancel">
      <ion-button @click="triggerFormSubmit(HOST_URL, 'cancel')" expand="block" size="large" color="medium" fill="outline" class="app-navigation-button">{{ data && data.cancellabel ? data.cancellabel : "Abbrechen" }}</ion-button>
    </div>
    <div v-if="hasButton('back')" class="button-outer button-back">
      <ion-button @click="triggerFormSubmit(data.back, 'back')" expand="block" size="large" class="app-navigation-button">{{ data.backlabel }}</ion-button>
    </div>
    <div v-if="hasButton('next')" class="button-outer button-next">
      <ion-button @click="triggerFormSubmit(data.next, 'next')" expand="block" size="large" class="app-navigation-button">{{ data.nextlabel }}</ion-button>
    </div>
    <div v-if="hasButton('finish')" class="button-outer button-finish">
      <ion-button @click="triggerFormSubmit(data.finish, 'finish')" expand="block" size="large" color="success" class="app-navigation-button">{{ data.finishlabel }}</ion-button>
    </div>
  </div>
</template>

<script lang="ts">
import { IonButton } from "@ionic/vue";
import { defineComponent, toRef } from "vue";
import { useStore } from "vuex";
import { HOST_URL } from "@/store";
import { SubmitStepAttrs } from "@/types";

export default defineComponent({
  name: "ButtonBar",
  emits: ["submitStep"],
  components: {
    IonButton,
  },
  props: {
    stepdata: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props) {
    const store = useStore();
    const data = toRef(props, "stepdata");

    const hasButton = (type: string): boolean => {
      if (props.stepdata && props.stepdata[type]) {
        return true;
      }
      return false;
    };

    const triggerFormSubmit = (url: string, button: string) => {
      const attrs: SubmitStepAttrs = { doSubmit: true, url, button };
      const stepData = data.value;
      if (stepData) {
        const loadingMsg: string | undefined = stepData[button + "loadingmsg"];
        if (loadingMsg) {
          attrs.loadingmsg = loadingMsg;
        }
        const delay: number | undefined = stepData[button + "delay"]
        if (delay) {
          setTimeout(() => {
            store.dispatch("main/submitStep", attrs);
          }, delay);
          return
        }
      }
      store.dispatch("main/submitStep", attrs);
    };

    return {
      HOST_URL,
      data,
      hasButton,
      triggerFormSubmit,
    };
  },
});
</script>

<style lang="scss" scoped>
.buttons-outer {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
  align-items: flex-start;
  padding: 1vh 1vw 2vh;
  border-top: 1px solid var(--ion-color-medium);

  .button-outer {
    flex-grow: 1;
    padding: 0 1vw;
  }
}
</style>